import React, { Suspense } from 'react';
import Footer from './Footer';
import { useImage } from 'react-image'
import { get_json, imagePath } from './common'
import { connect } from 'react-redux'
import ErrorBoundary from './Component/ErrorBoundary'
function ProductComponent(props) {
  const { src } = useImage({
    srcList: props.image
  })
  return (
    <img className={"collection-img"} src={src}></img>
  )
}
class All_collection extends React.Component {
  constructor() {
    super();
    this.state = {
      all_collection_arr:[]
    };
  }
  async componentDidMount() {
    window.scrollTo(0, 0)
    if (this.props.alldata === null) {
      await get_json(this)
      this.props.setresponseJson(this.state.data)
      this.filter_data()
    } else {
      await this.setState({ data: this.props.alldata })
      this.filter_data()
    }
  }
  async filter_data() {
    var sub_title = await window.location.href.match(/([^\/]*)\/*$/)[1];
    var collection_title = await window.location.href.split('/').slice(-2)[0]
    console.log(sub_title, collection_title, "cxcxc")
    let all_collection_arr=[];
    let all_collection = this.state.data.all_collection;
    if (typeof all_collection !== 'undefined') {
      if (all_collection.length > 0) {
        all_collection.forEach(async (item, i) => {
          if (item.subcollection_type === sub_title && item.collection_type === collection_title) {
            all_collection_arr.push(item)
          }
        });
      }
    }
    await this.setState({all_collection_arr:all_collection_arr });
  }
  // }
  redirect_page(product_image, product_name, product_information, product_price, product_code, product_brand, subcollection_type, collection_type) {

    this.props.history.push({ pathname: "/" + collection_type + "/" + subcollection_type + "/product/" + product_code, state: { subcollection_type: subcollection_type, collection_type: collection_type, product_image: product_image, product_name: product_name, product_information: product_information, product_price: product_price, product_code: product_code, product_brand: product_brand,currency_code:this.state.data.currency_code,currency_symbol:this.state.data.currency_symbol } });
  }

  render() {
    return (
      <div className="main_contact">
        <div className="gallery-main-sec w-left">
          <div className="container">
            <div className="center_text">
              <h3>{window.location.href.match(/([^\/]*)\/*$/)[1]} ({window.location.href.split('/').slice(-2)[0]})</h3>
            </div>
            <div className="row">
              {this.state.all_collection_type}
              {this.state.all_collection_arr.map((item,i)=>
                <div className="gallery-grid col-sm-6 col-md-4 main-collection" key={i}>
              <div className="inner-main-gallery collection-div">
                <a onClick={() => this.redirect_page(item.product_image, item.product_name, item.product_information, item.product_price, item.product_code, item.product_brand, item.subcollection_type, item.collection_type)}>
                  <div className="img-div-gallery">
                    <ErrorBoundary>
                      <Suspense fallback={<div className="place_effect showed"> <div className="img_div" /></div>
                      }
                      >
                        <ProductComponent image={imagePath + ((item.product_image.split(','))[0])}></ProductComponent>
                      </Suspense>
                    </ErrorBoundary>
                  </div>
                  <div className="all_collection-div">
                    <div className="deatils-pos-rel">
                      <span className="collection-span">{this.state.data.currency_symbol}: {this.state.data.currency_code==="EUR" ?(item.product_price*0.012).toFixed(3): this.state.data.currency_code==="USD" ?(item.product_price*0.014).toFixed(3):this.state.data.currency_code==="AED"?(item.product_price*0.051).toFixed(3):item.product_price}</span>
                    </div>
                    <div className="collection-detail-div">
                      <h2 className="collection-title-div">{item.product_name}</h2>
              {/* {        <p className="collection-description-div">{item.product_information}</p>} */}
                    </div>
                  </div>
                </a>
              </div>
            </div>)
              }
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}


// const mapStateToProps = (state) => {
//   console.log(state)
//   return {
//     alldata: state.responseJson,

//   }
// }
// const mapDispatchToProps = (dispatch) => {
//   return {
//     setresponseJson: (data) => dispatch({ type: "ALL_RESPONSE", payload: data }),
//   };
// };
// export default connect(mapStateToProps, mapDispatchToProps)(All_collection);

const mapStateToProps = (state) => {

  return {
    alldata: state.responseJson,

  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    setresponseJson: (data) => dispatch({ type: "ALL_RESPONSE", payload: data }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(All_collection);

// export default All_collection;


